import type { ReactNode } from "react";

interface TierHeaderProps {
  title: string;
  description?: string | null;
  className?: string;
}

export function TierHeader({
  title,
  description,
  className,
}: TierHeaderProps): ReactNode {
  if (!title && !description) {
    return null;
  }

  return (
    <hgroup className={`space-y-1 ${className || ""}`}>
      {title && (
        <h3 className="text-r8-lg font-sans font-semibold leading-tight">
          {title}
        </h3>
      )}
      {description && (
        <p className="text-r8-gray-11 text-r8-sm">{description}</p>
      )}
    </hgroup>
  );
}
